import { gql } from '@apollo/client'

export const Query = gql`
  query maintenanceTypeTasks(
    $companyId: ID!, 
    $filters: MaintenanceTypeTaskFilters, 
    $after: String, 
    $before: String, 
    $first: Int, 
    $last: Int
  ) {
    maintenanceTypeTasks(
      companyId: $companyId, 
      filters: $filters, 
      after: $after, 
      before: $before, 
      first: $first, 
      last: $last
    ) {
      nodes {
          id
          name
          required
          taskType
          maintenanceType { 
            id
            name
          }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
